import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { userService } from "@/shared/user/user.service";
import { useActions, useGetters } from "@/store/vuex-composition-mappers";
import { userThemesService } from "@/shared/themes/user-themes.service";
import { computed, onMounted } from "vue";
import { CardSquare, CardSquareColors, CardsSquare } from "@easy/ui/cards";
import { AddIcon } from "@easy/ui/icons";
import type { Theme } from "@/shared/themes/Theme.interface";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error

export default /*@__PURE__*/_defineComponent({
  __name: 'cCreatorThemes',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: /*@__PURE__*/_mergeModels(["updateColors"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {

const { brandingLink } = useGetters(["brandingLink"]);
// @ts-expect-error
const { colorThemes } = useGetters("theme", ["colorThemes"]);
// @ts-expect-error
const { getUserThemes } = useActions("theme", ["getUserThemes"]);
const model = _useModel<Theme>(__props, "modelValue");
const emit = __emit;

const currentTheme = computed<Theme>(() =>
    colorThemes.value.find((preset: Theme) => preset.id === model.value?.id)
);
const colorThemesWithoutUser = computed<Theme[]>(() =>
    colorThemes.value.filter((preset: Theme) => preset.id !== userThemesService.THEME_USER_ID)
);

onMounted(() => {
    getUserThemes();
});

function setTheme(theme: Theme) {
    model.value = theme;
    emit("updateColors", { theme });
}

async function goToBranding() {
    // @ts-expect-error
    const { magicUrl } = await userService.forgeMagicLink(brandingLink.value);
    window.open(magicUrl, "_blank");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CardsSquare), null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colorThemesWithoutUser.value, (preset) => {
        return (_openBlock(), _createBlock(_unref(CardSquareColors), {
          onClick: ($event: any) => (setTheme(preset)),
          key: preset.id,
          title: preset.name,
          colors: [
                preset.colors.brand,
                preset.colors.background,
                preset.colors.cardBackground,
                preset.colors.text,
            ],
          "is-selected": preset.id === currentTheme.value?.id
        }, null, 8, ["onClick", "title", "colors", "is-selected"]))
      }), 128)),
      _createVNode(_unref(CardSquare), {
        title: _ctx.$t('shared.creator.create_new'),
        onClick: goToBranding
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AddIcon), { class: "h-6 w-6 ct-fg-1" })
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }))
}
}

})